import { createSlice, PayloadAction } from "@reduxjs/toolkit";

type SliceState = {
  items: any[];
  discount: { amount: number | null; type: string };
  localId: number;
  totalQty: number;
  customer: any;
  totalPrice: number;
  finalPrice: number;
  totalTax: number;
  isOpened: boolean;
  invoiceNo: string | null;
  selectedItem: { id: number };
  deliveryCharge: number | null;
  deliveryLocation: {
    id: number | null,
    location: string | null
  };
  deliveryChargeText: string | null,
  invoiceType: {
    id: number | null,
    typeName: string | null,
    isActive: boolean | null
  },
};
interface Specification {
  isComponent: boolean;
  specificationId: number;
  extraCharge: number;
  quantity: number;
  notes: string;
}

const initialState: SliceState = {
  items: [],
  invoiceNo: null,
  discount: { amount: 0, type: "#" },
  localId: 0,
  totalQty: 0,
  customer: {},
  totalPrice: 0,
  finalPrice: 0,
  totalTax: 0,
  isOpened: false,
  selectedItem: { id: 0 },
  deliveryCharge: null,
  deliveryLocation: {
    id: null,
    location: null
  },
  deliveryChargeText: null,
  invoiceType: {
    id: null,
    typeName: null,
    isActive: null
  },
};

const calculateTotal = (items: any[]): number => {
  let total = 0;
  // eslint-disable-next-line array-callback-return
  items.map((item) => {
    total += item.price * item.qty;
  });
  return total;
};

const mainSlice = createSlice({
  name: "main",
  initialState,
  reducers: {
    addItem(state, action: PayloadAction<any>) {
      const newItem = { localId: state.localId, ...action.payload };
      state.items.push(newItem);
      state.totalPrice += Number(newItem.price) * newItem?.qty;
      state.localId = state.localId + 1;
    },
    setCustomer(state, action: any) {
      state.customer = action.payload;
    },
    removeCustomer(state) {
      state.customer = {};
    },

    selectedItemId(state, action: PayloadAction<{ id: number }>) {
      state.selectedItem = action.payload;
    },
    addSpecification(state, action: PayloadAction<Specification[]>) {
      const selectedItem = state.items.find(
        (item) => item.localId === state.selectedItem
      );
      selectedItem.specifications = action.payload;
      let total = 0;
      if (
        selectedItem.specifications &&
        selectedItem.specifications.length > 0
      ) {
        total = selectedItem.specifications.reduce(
          (accumulator: number, specification: { extraCharge: number }) => {
            return accumulator + specification.extraCharge;
          },
          0
        );
      }
      selectedItem.extraCharge = total;
    },

    addQty(state, action: PayloadAction<{ id: number; qty: number }>) {
      const existingItem = state.items.find(
        (item) => item.id === action.payload.id
      );

      if (existingItem) {
        if (action.payload.qty < 0) {
          if (existingItem.qty > 1) {
            existingItem.qty += action.payload.qty;
            state.totalPrice -= Number(existingItem.price);
          }
        } else {
          existingItem.qty += action.payload.qty;
          state.totalPrice += Number(existingItem.price);
        }
      }
    },

    setQty(state, action: PayloadAction<{ id: number; qty: number }>) {
      const existingItem = state.items.find(
        (item) => item.localId === action.payload.id
      );

      if (existingItem) {
        const newqty = action.payload.qty - existingItem.qty;
        existingItem.qty += newqty;
        state.totalPrice += Number(existingItem.price) * newqty;
      }
    },

    deleteItem(state, action: PayloadAction<{ id: number }>) {
      const existingItem = state.items.find(
        (item) => item.localId === action.payload.id
      );
      if (existingItem) {
        state.totalPrice =
          state.totalPrice - existingItem.qty * Number(existingItem.price);
        state.items = state.items.filter(
          (item) => item.localId !== action.payload.id
        );
      }
    },
    addDiscount(
      state,
      action: PayloadAction<{ amount: number | null; type: string }>
    ) {
      state.discount = { ...action.payload };
    },
    addDelivery(
      state,
      action: PayloadAction<{
        deliveryCharge: number | null,
        deliveryLocation: {
          id: number | null,
          location: string | null
        },
        deliveryChargeText: string | null
      }>
    ) {
      state.deliveryCharge = action.payload.deliveryCharge
      state.deliveryLocation = action.payload.deliveryLocation
      state.deliveryChargeText = action.payload.deliveryChargeText
    },
    restoreOrder(state, action: PayloadAction<[]>) {
      state.items = action.payload;
      state.items.map((item): void => {
        if (state.localId <= item.localId) state.localId = item.localId + 1;
        // eslint-disable-next-line array-callback-return
        return;
      });
      state.totalPrice = calculateTotal(state.items);
    },
    setFinalPrice(state, action: PayloadAction<number>) {
      state.finalPrice = action.payload;
    },
    setInvoiceNo(state, action: PayloadAction<string>) {
      state.invoiceNo = action.payload;
    },
    clearInvoiceNo(state) {
      state.invoiceNo = null;
    },
    setInvoiceType(
      state,
      action: PayloadAction<{
        id: number | null,
        typeName: string | null,
        isActive: boolean | null
      }>
    ) {
      state.invoiceType.id = action.payload.id
      state.invoiceType.typeName = action.payload.typeName
      state.invoiceType.isActive = action.payload.isActive
    },

    clearInvoice(state) {
      if (!state.isOpened) {
        state.items = [];
        state.totalPrice = 0;
        state.localId = 0;
        state.discount = { amount: 0, type: "#" };
        state.totalQty = 0;
        state.customer = {};
        state.totalTax = 0;
        state.finalPrice = 0;
        state.invoiceNo = null;
      }
    },
  },
});

export const mainActions = mainSlice.actions;
export const mainReducer = mainSlice.reducer;
